<template>
  <div class="patrolExceptionList">
    <el-card>
      <el-table
      :data="tableData"
      class="wid100"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      :height="tableData.length > 0 ? require('@/config/enum').tableheight730 : require('@/config/enum').tableheight132"
      >
        <el-table-column type="selection" width="55" v-if="patrolExceptionListbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column
          prop="patrolPointLineName"
          :label="$t('lang.lab_lineName')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.patrolPointLineName&&scope.row.patrolPointLineName.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.patrolPointLineName }}
                </span>
              </div>
              <div>
                {{ scope.row.patrolPointLineName.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span
                  v-if="scope.row.patrolPointLineName.length>require('@/config/enum').tableDatamaxlength10"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.patrolPointLineName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="excPosition"
          :label="$t('lang.lab_abnormalPosition')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.excPosition&&scope.row.excPosition.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.excPosition }}
                </span>
              </div>
              <div>
                {{ scope.row.excPosition.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span
                  v-if="scope.row.excPosition.length>require('@/config/enum').tableDatamaxlength10"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.excPosition | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="info"
          :label="$t('lang.lab_abnormalDescription')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.info&&scope.row.info.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.info }}
                </span>
              </div>
              <div>
                {{ scope.row.info.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span
                  v-if="scope.row.info.length>require('@/config/enum').tableDatamaxlength10"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.info | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="urls"
          :label="$t('lang.lab_picture')"
          width="320px">
          <template slot-scope="scope" >
            <viewer :images="scope.row.urls" class="img-width">
              <img v-for="(src,index) in scope.row.urls" 
              :src="src"
              :key="index"
              class="img">
            </viewer>
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          :label="$t('lang.lab_feedbackPerson')"
          width="200px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.staffName&&scope.row.staffName.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.staffName }}
                </span>
              </div>
              <div>
                {{ scope.row.staffName.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span
                  v-if="scope.row.staffName.length>require('@/config/enum').tableDatamaxlength10"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.staffName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('lang.lab_feedbackTime')"
          width="200px">
          <template slot-scope="scope">
            {{ scope.row.createTime | time }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:patrolExceptionList
 *@Description:异常记录
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-02-25
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 1, // 总页数
      tableData: [], // 列表数据
      images: [], // 图片集合
      // urls: ['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg', 'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg', 'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg', 'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'], // 测试图片数据
      patrolExceptionListbox: require('@/config/enum').patrolExceptionListbox, // 是否隐藏复选框
      multipleSelection: [], // 多选框 
    }
  },
  created() {
    this.getData()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.getData()
    }
  },
  methods: {
    getData() {
      let loading = this.$loading()
      this.$get(`/patrolException/?GardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          console.log('res', res)
          this.tableData = res.list
          // for-test
          // if (this.tableData[0].urls.length === 0 && this.tableData.length != 0) {
          //   this.tableData[0].urls = this.urls
          // }
          this.pageCount = res.pageCount
        }, 
        error => {
          loading.close()
          this.$message.error(error)
        })
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
  }
}
</script>

<style lang="scss">
.patrolExceptionList{
  .img {
    width: 80px;
    height: 50px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
  }
  .img-width {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 320px;
  }
}
.el-tooltip__popper.is-light {
  max-width: 300px;
}
</style>